import { cityIn, cityFrom, cityTo } from 'lvovich';

const exceptions = [
    {
        name: 'Алма-Ата',
        from: 'Алма-Аты',
        to: 'Алму-Ату',
        in: 'Алма-Ате',
    },
    {
        name: 'Афины',
        from: 'Афин',
        to: 'Афины',
        in: 'Афинах',
    }
];

const exceptionsMapFrom = new Map();
const exceptionsMapTo = new Map();

exceptions.forEach(item => {
    exceptionsMapFrom.set(item.name, item.from)
});

exceptions.forEach(item => {
    exceptionsMapTo.set(item.name, item.to)
});


class Declension {
    constructor(words, getMessage) {
        this.words = words;
        this.getMessage = getMessage;
    }

    fromCity(options) {
        if (this._validateIata(options.iata)) {
            return this._validateIata(options.iata);
        }
        else if (exceptionsMapFrom.has(options.city)) {
            return exceptionsMapFrom.get(options.city);
        } else {
            return cityFrom(options.city);
        }
    }

    toCity(options) {
        if (this._validateAccusative(options.iata)) {
            return this._validateAccusative(options.iata);
        }
        else if (exceptionsMapTo.has(options.city)) {
            return exceptionsMapTo.get(options.city);
        } else {
            return cityTo(options.city);
        }
    }

    inCity(options) {
        if (this._validatePrepositional(options.iata)) {
            return this._validatePrepositional(options.iata);
        }
        else if (exceptionsMapTo.has(options.city)) {
            return exceptionsMapTo.get(options.city);
        } else {
            return cityIn(options.city);
        }
    }

    onCity(options) {
        if (this._validateDative(options.iata)) {
            return this._validateDative(options.iata);
        }
        else if (exceptionsMapTo.has(options.city)) {
            return exceptionsMapTo.get(options.city);
        } else {
            return options.city;
        }
    }

    _validateAccusative(iata) {
        let result;

        if(iata) {
            result = this.getMessage(this.words, `com.s7.cities.${iata}.accusative`);
        } else {
            return result = false;
        }

        if (result !== `com.s7.cities.${iata}.accusative`) {
            return result;
        }
    }

    _validatePrepositional(iata) {
        let result;

        if(iata) {
            result = this.getMessage(this.words, `com.s7.cities.${iata}.prepositional`);
        } else {
            return result = false;
        }

        if (result !== `com.s7.cities.${iata}.prepositional`) {
            return result;
        }
    }

    _validateIata(iata) {
        let result;

        if(iata) {
            result = this.getMessage(this.words, `com.s7.cities.${iata}.genitive`);
        } else {
            return result = false;
        }

        if (result !== `com.s7.cities.${iata}.genitive`) {
            return result;
        }
    }

    _validateDative(iata) {
        let result;

        if(iata) {
            result = this.getMessage(this.words, `com.s7.cities.${iata}.dative`);
        } else {
            return result = false;
        }

        if (result !== `com.s7.cities.${iata}.dative`) {
            return result;
        }
    }
}

export { Declension };
